export const DEFAULT_PATH = "/";
export const BASE_PATH = "/settings";
export const OVERVIEW_PATH = "overview";
export const PEOPLE_PATH = "people";
export const API_MCP_PATH = "api-mcp";
export const UNKNOWN_TAB_PATH = ":unknownTab";
export const DEFAULT_OVERVIEW_PATH = `/${OVERVIEW_PATH}`;
export const DEFAULT_PEOPLE_PATH = `/${PEOPLE_PATH}`;
export const DEFAULT_API_MCP_PATH = `/${API_MCP_PATH}`;
export const OVERVIEW_PATH_WILDCARD = `${OVERVIEW_PATH}/*`;
export const PEOPLE_PATH_WILDCARD = `${PEOPLE_PATH}/*`;
export const API_MCP_PATH_WILDCARD = `${API_MCP_PATH}/*`;
export const UNKNOWN_TAB_PATH_WILDCARD = `${UNKNOWN_TAB_PATH}/*`;
